// extracted by mini-css-extract-plugin
export var textInput = "_dc-0";